import Vue from 'vue'

const actions = {
  async uploadPatientDocument(_, { file, patientId }) {
    if (!file) return { success: false, message: 'File is required' }
    if (!patientId) return { success: false, message: 'Patient ID is required' }

    const formData = new FormData()
    formData.append('file', file)
    formData.append('patientId', patientId)

    const result = await Vue.$http.post('/Documents/patient/upload', formData)

    return result?.data || { success: false, message: 'Upload failed' }
  },

  async downloadDocumentFile(_, { id }) {
    if (!id) return null

    try {
      const { status, data } = await Vue.$http.get(`/Documents/${id}/download`, {
        responseType: 'blob',
      })

      return status === 200 ? data : null
    } catch (e) {
      if (e.response?.status === 400 || e.response?.status === 404) {
        return null
      }

      throw e
    }
  },

  async downloadDocumentsZip(_, { patientId, documentIds }) {
    if (!patientId || !documentIds?.length) return null

    const { status, data } = await Vue.$http.post('/Documents/download-zip', {
      patientId,
      documentIds
    }, { responseType: 'blob' })

    return status === 200 ? data : null
  },

  async sendDocumentsToPatient(_, { patientId, documentIds }) {
    if (!patientId || !documentIds?.length) {
      return { success: false }
    }

    const result = await Vue.$http.post('/Documents/send-to-patient', {
      patientId,
      documentIds
    })
    return result?.data || { success: false }
  },

  async removePatientDocument(_, documentId) {
    if (!documentId) return { success: false }

    const result = await Vue.$http.delete(`/Documents/patient/remove/${documentId}`)
    return result?.data || { success: false }
  }
}

export default {
  namespaced: true,
  actions
}
